// Src
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthenticationReducerState } from '../types/authenticationTypes';

export const initialState: AuthenticationReducerState = {
    loggedIn: false,
};

export const authenticationSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        updateAuthAction: (state, action: PayloadAction<AuthenticationReducerState>) => {
            state.userId = action.payload.userId;
            state.loggedUserInfo = action.payload.loggedUserInfo;
            state.loggedIn = true;
        },
        logoutRequestAction: (state) => {
            state.loggedIn = false;
            state.loggedUserInfo = undefined;
            state.userId = undefined;
        },
    },
});

export const { updateAuthAction, logoutRequestAction } = authenticationSlice.actions;

export default authenticationSlice.reducer;
